/* unplugin-vue-components disabled */import script from "./CapabilityRadar.vue?vue&type=script&setup=true&lang=js"
export * from "./CapabilityRadar.vue?vue&type=script&setup=true&lang=js"

import "./CapabilityRadar.vue?vue&type=style&index=0&id=12f9183a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12f9183a"]])

export default __exports__